import { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { SearchQuerySelect } from "./select";
import { SearchQuerySubmit } from "./submit";
import { WafFriendlyPass } from "src/types/waf-friendly-pass";
import { useRouter } from "next/router";
import styles from './style.module.scss';
import { sleep } from "src/utils/sleep";

type Props = {
  areas: WafFriendlyPass.taxonomy[]
  features: WafFriendlyPass.taxonomy[]
  pathname?: string
  setState: (state: boolean) => void
  setFilterSubmitState: (state: boolean) => void
}

type FormProps = {
  area: string
  hotel_feature: string
}

const HotelSearchQuery: React.VFC<Props> = ({ areas, features, pathname, setState, setFilterSubmitState }) => {
  const methods = useForm<FormProps>()
  const router = useRouter()
  const [queryState, setQueryState] = useState(false)

  const search = useCallback(async data => {
    setState(true)
    setQueryState(data.area === '' && data.hotel_feature === '')
    if (queryState) { return }

    if (data.area === '' && data.hotel_feature === '') {
      delete data.area
      delete data.hotel_feature
    }

    if (data.area === '') {
      delete data.area
    }

    if (data.hotel_feature === '') {
      delete data.hotel_feature
    }

    router.push({
      pathname: pathname,
      query: data
    }, undefined)

    setFilterSubmitState(true)
  }, [])

  return (
    <FormProvider {...methods}>
      <div className={styles.searchQuery}>
        <SearchQuerySelect name="area" label="エリアから探す" items={areas} />
        <SearchQuerySelect name="hotel_feature" label="特徴から探す" items={features} />
        <SearchQuerySubmit onClick={methods.handleSubmit(search)} />
      </div>
    </FormProvider>
  )
}

export { HotelSearchQuery }
